function fatHa(t) {
  return [[0,1], t + .6];
}

module.exports = [[[-35, -130], fatHa, [35, 129]]];



/*****************
 ** WEBPACK FOOTER
 ** ../JSCalligrapher/alphabets/abjad/fatHa.js
 ** module id = 18
 ** module chunks = 0
 **/